import React, { useEffect } from "react";
import { Outlet, useRoutes } from "react-router-dom";
import "./App.css";
import Header from "./components/Header/Header";
import Products from "./components/Products/Products";
import Basket from "./components/Basket/Basket";
import Details from "./components/Details/Details";
import FavoritePage from "./components/Favorite/FavoritePage";
import Login from "./components/Login/Login";
import Checkout from "./components/Checkout/Checkout";
import Confirmation from "./components/Confirmation/Confirmation";
import Orders from "./components/Orders/Orders";
import SelectLocation from "./components/Address/SelectLocation";
import Account from "./components/Account/Account";
import EventRegistration from "./components/EventRegistration/EventRegistration";
import ContentPages from "./components/ContentPages/ContentPages";
import PriceAndStockList from "./components/PriceAndStockList/PriceAndStockList";

import { Provider, useDispatch } from "react-redux";
import { store } from "./app/store";
import { initializeUser } from "./features/user/userSlice";

const NotFound = () => <div style={{ padding: 24 }}>Page not found</div>;

const AppLayout = () => (
  <>
    <div className="app-container">
      <Header />
      <Outlet />
    </div>
  </>
);

/**
 * The main component for the application.
 * @return {JSX.Element} The rendered App component.
 */
function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initializeUser());
  }, [dispatch]);

  const router = useRoutes([
    {
      path: "/",
      element: <AppLayout />,
      children: [
        { index: true, element: <SelectLocation /> },
        { path: "products", element: <Products /> },
        { path: "products/:id", element: <Products /> },
        { path: ":id", element: <Details /> },
        { path: "favorite", element: <FavoritePage /> },
        { path: "basket", element: <Basket /> },
        { path: "login", element: <Login /> },
        { path: "account", element: <Account /> },
        { path: "checkout", element: <Checkout /> },
        { path: "confirmation", element: <Confirmation /> },
        { path: "orders", element: <Orders /> },
        { path: "event/:id", element: <EventRegistration /> },
        { path: "creatives", element: <ContentPages /> },
        { path: "stock", element: <PriceAndStockList /> },
        // Catch-all 404 under the app’s base
        { path: "*", element: <NotFound /> }
      ]
    }
  ]);

  return (
    <React.StrictMode>
      <Provider store={store}>{router}</Provider>
    </React.StrictMode>
  );
}

export default App;
